import { useCallback, useState } from 'react';

// hooks / apis
import { useUserMutation } from 'api/account';

// material-ui
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';

// icons
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import SendIcon from '@material-ui/icons/Send';

// components
import Button from 'components/Button';
import Header from 'components/Header';
import StaffMemberSelector from './components/StaffMemberSelector';

const GrantSystemAdminCard = () => {
  const classes = useStyles();

  const [selectedStaffMember, setSelectedStaffMember] = useState<User | null>(
    null
  );
  const [opened, setOpened] = useState(false);

  const {
    isLoading: adminStateLoading,
    isSuccess: isSubmitSucceeded,
    isError: isSubmitFailed,
    mutate,
  } = useUserMutation({ onSuccess: () => setSelectedStaffMember(null) });

  const toggleOpened = useCallback(() => setOpened(true), []);
  const toggleClosed = useCallback(() => setOpened(false), []);

  const handleValueChange = useCallback((_, val: string | User | null) => {
    if (typeof val !== 'string') {
      setSelectedStaffMember(val);
    }
  }, []);

  const handleSubmit = () => {
    if (selectedStaffMember?.id) {
      mutate({ ...selectedStaffMember, isSystemAdmin: true });
    }
  };

  return (
    <Grid item xs={12}>
      <Card className={classes.topCard}>
        <CardContent>
          <Grid container spacing={2} alignItems='flex-start'>
            <Grid item xs={12} sm={7} md={9} xl={10}>
              <Header
                icon={PersonAddIcon}
                title='Grant System Admin Access'
                subtitle='Choose a user from the input below and grant system admin access'
              />
            </Grid>
          </Grid>

          <Grid container spacing={4} alignItems='center'>
            <Grid item xs={10} sm={6}>
              <StaffMemberSelector
                opened={opened}
                selectedStaffMember={selectedStaffMember}
                toggleOpened={toggleOpened}
                toggleClosed={toggleClosed}
                handleValueChange={handleValueChange}
              />
            </Grid>
            <Grid item xs={2} sm='auto'>
              <Button
                id='grantSystemAdminButton'
                type='submit'
                onClick={handleSubmit}
                fabIcon={<SendIcon />}
                color='primary'
                variant='outlined'
                disabled={!selectedStaffMember}
                loading={adminStateLoading}
                fail={isSubmitFailed}
                success={isSubmitSucceeded}
              >
                <SendIcon className={classes.submitButtonIcon} />
                Grant
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

const useStyles = makeStyles({
  topCard: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  submitButtonIcon: {
    marginRight: 10,
  },
});

export default GrantSystemAdminCard;
